The `CandidateProfile` that the `CandidateProcessHistoryItem` relates to.
